/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_OkInputs */

const en_tut_tampilan_ok = /** @type {(inputs: Tut_Tampilan_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes apply immediately with no save button, and the selected card is ticked.`)
};

const id_tut_tampilan_ok = /** @type {(inputs: Tut_Tampilan_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan langsung diterapkan tanpa tombol simpan, dan kartu yang terpilih ditandai centang.`)
};

/**
* | output |
* | --- |
* | "Changes apply immediately with no save button, and the selected card is ticked." |
*
* @param {Tut_Tampilan_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_ok = /** @type {((inputs?: Tut_Tampilan_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_ok(inputs)
	return en_tut_tampilan_ok(inputs)
});